import { usePermission } from '@/lib/permissions'
import type { TabAccess } from '@/lib/pageTabs'
import { useFeatureFlags } from '@/providers/FeatureFlagsProvider'

/**
 * What the tab gates in `src/lib/pageTabs.ts` read, for the selected tenant.
 * One hook for the pages and the main menu, so both resolve a tab the same way.
 */
export function useTabAccess(): TabAccess {
  const { can, isSuperAdmin } = usePermission()
  const { flags, isLoading } = useFeatureFlags()
  // Same semantics as useFeatureFlag: open while loading, open for a key the
  // backend has not shipped.
  const featureOn = (key: string) => isLoading || flags[key] !== false
  return { can, isSuperAdmin, featureOn }
}
